export default function initPasswordToggler(): void {
    const $inputs = document.querySelectorAll<HTMLInputElement>('.js-input-password');

    $inputs.forEach($input => {
        const $toggler = $input.parentElement?.querySelector<HTMLButtonElement>('.js-hide-password');

        $toggler?.addEventListener('click', () => {
            if ($input.type === 'password') {
                $input.type = 'text';
            } else {
                $input.type = 'password';
            }
        });
    });
}
